import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import Ico from './iconBox';

// import HomeBlog from '../assets/images/blog_1.jpg';
// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';

class Home extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <div>
            
 


<br />



<div className="container">
    <div className="row">
        <div className="col-12">
  
  











<div>
<h1><strong>Privacy Notice&nbsp;</strong></h1>
<br /><br />
<p><strong>YOVHO is dedicated to safeguarding your personal data.</strong>&nbsp;This privacy statement outlines the types of information we gather, how we utilize it, and the measures we take to ensure its security. It also describes the rights you may have under relevant data protection laws and provides guidance on how to reach out to us if you have any concerns regarding the handling of your information.</p>
<hr />
<h3><strong>About YOVHO</strong></h3>
<p>In this notice, references to&nbsp;<strong>&ldquo;YOVHO&rdquo;</strong>,&nbsp;<strong>&ldquo;YOVHO Rooms&rdquo;</strong>,&nbsp;<strong>"we"</strong>,&nbsp;<strong>"our"</strong>, or&nbsp;<strong>"us"</strong>&nbsp;refer to&nbsp;<strong>YOVHO Stays UAE Pte. Limited</strong>, a company registered in the&nbsp;<strong>United Arab Emirates</strong>, along with its parent organization and affiliated entities (collectively known as the&nbsp;<strong>&ldquo;YOVHO Group&rdquo;</strong>). To view our company&rsquo;s contact details, please click here&nbsp;<a href="mailto:info@yovho.com" target="_blank">info@yovho.com</a></p>
<p>Depending on your method of engagement with us&mdash;such as through our mobile application, by staying at a YOVHO-branded location, or by making a reservation through an external travel agency&mdash;various entities within the YOVHO Group may be involved in managing your information. For details on which YOVHO entity is responsible for making decisions about the processing of your data, feel free to contact us.<br /><br /><br /></p>
<h3><strong>Scope of This Privacy Notice</strong></h3>
<p>This privacy notice is applicable to any individual who engages with us regarding our products or services (&ldquo;you,&rdquo; &ldquo;your&rdquo;), through any means of communication&mdash;such as our mobile app, website, email, telephone, physical visits to YOVHO-branded properties, or reservations made via third-party travel platforms. In certain instances, we may also issue supplementary privacy statements for specific interactions.</p>
<p>If you make a reservation through us at one of our partner properties (such as guest houses, hotels, or other types of lodging that are&nbsp;<strong>not</strong>&nbsp;YOVHO-branded), the respective partner will manage your personal data in accordance with their own privacy policy.</p>
<p>This notice is intended for people who inquire about, purchase, or utilize our services&mdash;whether that includes creating an account with YOVHO, modifying account details, making reservations (via app, website, walk-in, or other channels), using on-demand services, reaching out to customer support, staying at a YOVHO-branded location, or otherwise engaging with us.</p>
<p>It explains how your data is handled no matter how you get in touch with us&mdash;be it through our app, website, by email or phone, or in person at a YOVHO-branded facility. In some cases, we may offer additional details depending on the nature of the interaction. For instance, certain app features may come with their own data-use explanations.</p>
<p>YOVHO provides accommodation at both YOVHO-branded properties and partner locations. YOVHO-branded accommodations are clearly marked with the "YOVHO" name. If you book a stay at one of our partners&rsquo; locations, they will handle your personal data according to their own privacy policies, usually accessible on their website or provided during booking or check-in.</p>
<p>Please note that our website and app are not designed for children, and individuals under legal adult age are not allowed to book or stay in YOVHO accommodations unless accompanied by a responsible adult. As such, this privacy notice is not intended for minors. If you provide us with details about your children, we will process that information in line with this notice.</p>
<p>If you have any concerns or questions regarding this, we encourage you to contact us.</p>
<hr />
<h3><strong>How We Collect Personal Information</strong></h3>
<p>We gather personal data both directly from you and from third parties such as travel agents or individuals who make bookings on your behalf.</p>
<p>If you share personal details about others (e.g., guests who will be staying with you), you are responsible for ensuring they are aware of this privacy policy and consent to the sharing of their data.</p>
<p>Your personal information may be collected through your interactions with us via:</p>
<ul>
<li>
<p>Phone calls (which may be recorded for compliance and quality monitoring),</p>
</li>
<li>
<p>Email correspondence,</p>
</li>
<li>
<p>Our official websites and mobile apps,</p>
</li>
<li>
<p>Postal mail,</p>
</li>
<li>
<p>Social media platforms,</p>
</li>
<li>
<p>In-person meetings at YOVHO-branded accommodations or through YOVHO representatives.</p>
</li>
</ul>
<p>We also receive your data from third parties including:</p>
<p>&nbsp;</p>
<p>a. Individuals or agents making bookings on your behalf,<br />b. Travel agencies through which reservations are made from other travel platforms.<br />c. Accommodation providers affiliated with us,<br />d. Service partners that support the delivery of our offerings, and<br />e. If your role involves corporate travel, business partners or third-party sources may identify you as a contact for offering our services to your organization.<br /><br /><br /><strong>&nbsp;Personal Data Type of personal data we handle:</strong><br /><br /></p>
<p>We process two main categories of personal information relating to you and, if applicable, individuals you have booked accommodation for:</p>
<ol>
<li>
<p><strong>General Personal Data</strong>&nbsp;&ndash; Information used to identify, contact, and manage our relationship with you.</p>
</li>
<li>
<p><strong>Sensitive Personal Data</strong>&nbsp;&ndash; Specific types of information protected under applicable law, such as health-related requests or religious preferences.</p>
</li>
</ol>
<p>Please see below for details.</p>
<hr />
<h4><strong>General Personal Data</strong></h4>
<p>a.&nbsp;<strong>Contact Information</strong>:<br />Includes your name, address, phone number, email, date of birth, gender, nationality, and country of residence. If you link a social media profile, we may collect your profile picture.</p>
<p>b.&nbsp;<strong>Location Data</strong>:<br />We may estimate your location using your IP address or, if permitted, collect your precise device location through our app to suggest nearby accommodations.</p>
<p>c.&nbsp;<strong>Booking and Transaction Records</strong>:<br />We record details such as services requested, booking/stay dates, duration, payment amounts, and referral tracking (if applicable).</p>
<p>d.&nbsp;<strong>Account and Communication History</strong>:<br />We maintain a record of your bookings, complaints, support interactions, or incidents you&rsquo;ve reported.</p>
<p>e.&nbsp;<strong>Usage and Technical Information</strong>:<br />This includes how you interact with our platforms (web/app), search terms, device type, IP address, crash reports, and browsing history. See our Cookie Policy for details.</p>
<p>f.&nbsp;<strong>Device Data</strong>:<br />We collect details about your mobile device and software to enhance performance, including system version, device ID, language preferences, and mobile network.</p>
<p>g.&nbsp;<strong>Call &amp; SMS Logs</strong>:<br />For communication with property managers, we may log the date, time, and content of calls or messages made through our system.</p>
<p>h.&nbsp;<strong>CCTV</strong>:<br />Video footage may be recorded when you enter our premises to ensure safety and security.</p>
<p>i.&nbsp;<strong>Wi-Fi Access</strong>:<br />When you use Wi-Fi in YOVHO&nbsp;Partner properties, we collect login credentials and monitor usage patterns.</p>
<hr />
<h4><strong>Sensitive Personal Data</strong></h4>
<p>In some cases, you may share personal details that fall under legally protected categories. These include:</p>
<p>&nbsp;</p>
<ul>
<li>
<p><strong>Dietary or Religious Preferences</strong>: Such as requests for requested meals.</p>
</li>
<li>
<p><strong>Medical or Accessibility Needs</strong>: Such as mobility support or health-related accommodation requests.</p>
</li>
<li>
<p><strong>Relationship Information</strong>: If you disclose that you are traveling with a spouse or family member.<br /><br /><br /></p>
<p>Please note that&nbsp;<strong>YOVHO accommodations are exclusively available to</strong>:</p>
<ul>
<li>
<p><strong>Families</strong></p>
</li>
<li>
<p><strong>Solo travelers</strong></p>
</li>
<li>
<p><strong>Business travelers</strong></p>
</li>
</ul>
<p>&nbsp;</p>
<p>As part of our commitment to family-friendly and professional standards,&nbsp;<strong>unmarried couples are not permitted to book or share the same room</strong>&nbsp;at any YOVHO-branded property. We may verify guest relationships at check-in, and reservations that do not comply with this policy may be declined.<br /><br />&nbsp;YOVHO accommodations are intended exclusively for&nbsp;<strong>families</strong>,&nbsp;<strong>solo travelers</strong>, and&nbsp;<strong>business travelers</strong>. In accordance with our policy,&nbsp;<strong>unmarried couples are not permitted to book or share a room</strong>&nbsp;at YOVHO Partner properties. We reserve the right to verify guest relationships during the check-in process and may refuse accommodation where this policy is not met.&nbsp;&nbsp;<br /><br /><br /><br /></p>
<h4><strong>Purpose and lawful grounds for processing personal information:</strong>:</h4>
<p>YOVHO processes your personal data for the purposes outlined in this privacy notice, based on the lawful grounds provided under applicable data protection regulations. The legal basis for processing your information may vary depending on the type of data and the specific context of your interaction with us.</p>
<hr />
<h4><strong>1. Standard Personal Information</strong></h4>
<p>We process standard personal information on the following legal grounds:</p>
<p><strong>a. Contractual Necessity</strong><br />Where a contract exists between you and YOVHO, we process your information as required to perform our contractual obligations. This includes managing bookings, providing accommodations, and delivering related services for you or others included in your reservation.</p>
<p><strong>b. Legitimate Interests</strong><br />We may process your personal information where necessary for our or third parties&rsquo; legitimate interests, provided those interests are not overridden by your rights and freedoms. These interests may include:</p>
<ul>
<li>
<p>Enhancing and maintaining the quality of our services</p>
</li>
<li>
<p>Responding to customer queries and complaints</p>
</li>
<li>
<p>Preventing fraud and ensuring the security of our services</p>
</li>
<li>
<p>Marketing and business analytics (with appropriate safeguards)</p>
</li>
</ul>
<p><strong>c. Legal Compliance</strong><br />We may also process your data where it is required or explicitly permitted under applicable law or regulation.</p>
<hr />
<h4><strong>2. Special Category (Sensitive) Information</strong></h4>
<p>Special category data includes information revealing your health status, religious beliefs, or other protected characteristics under applicable law. This data is only processed under strict conditions, such as:</p>
<p><strong>a. Information Made Public by You</strong><br />If you have voluntarily disclosed special category information (e.g. dietary preferences based on religion or the nature of a celebration such as a wedding), we may process such data accordingly.</p>
<p><strong>b. Substantial Public Interest (Based on Law)</strong><br />In certain cases, such as a medical emergency or safety-related incident during your stay, we may process relevant information to ensure proper handling, documentation, and reporting.</p>
<p><strong>c. Explicit Consent</strong><br />Where legally required, we will seek your clear and informed consent before processing any special category information. Consent is not implied by reading this privacy notice.</p>
<p>&nbsp;</p>
<p><strong>d. Legal Claims</strong><br />We may process special category information where necessary to establish, exercise, or defend legal claims.<br /><br /><br /><br /></p>
<h4><strong>Legitimate interest :&nbsp;</strong></h4>
<p>We process your personal information for a range of legitimate business purposes. These include delivering our services, managing our relationship with you, improving our offerings, conducting marketing (where lawful), and protecting our legal rights. Below are the key legitimate interests under which YOVHO processes personal data, in accordance with applicable law.</p>
<p>We always ensure that our interests do not override your rights, freedoms, or reasonable expectations.</p>
<hr />
<h4><strong>Our Legitimate Interests Include:</strong></h4>
<p><strong>a. Service Delivery and Administration</strong><br />To provide and manage the products and services you book with us, such as:</p>
<ul>
<li>
<p>Fulfilling accommodation and service requests</p>
</li>
<li>
<p>Operating loyalty programs (where applicable)</p>
</li>
<li>
<p>Sending service-related communications, including confirmations and updates</p>
</li>
<li>
<p>Processing payments, generating receipts, and offering customer support</p>
</li>
</ul>
<p><strong>b. Relationship and Vendor Management</strong><br />To manage our interactions with you and our partners, including:</p>
<ul>
<li>
<p>Handling feedback or complaints</p>
</li>
<li>
<p>Verifying service quality from third-party providers</p>
</li>
<li>
<p>Ensuring accurate billing and service delivery</p>
</li>
</ul>
<p><strong>c. Security and Authentication</strong><br />To ensure secure and safe interactions with our platforms, such as:</p>
<ul>
<li>
<p>Verifying your identity</p>
</li>
<li>
<p>Preventing unauthorized access to your account or our services</p>
</li>
</ul>
<p><strong>d. Product and Service Improvement</strong><br />To improve the YOVHO app, website, and services by:</p>
<ul>
<li>
<p>Diagnosing bugs or performance issues</p>
</li>
<li>
<p>Conducting data analysis, testing, and customer research</p>
</li>
<li>
<p>Monitoring usage trends and feedback</p>
</li>
</ul>
<p><strong>e. Marketing and Personalization</strong><br />To send you updates and promotional content we believe may interest you, including:</p>
<ul>
<li>
<p>Information about our services, promotions, news, and features</p>
</li>
<li>
<p>Personalized content, recommendations, or advertisements<br />You may opt out of marketing communications at any time using the unsubscribe link in our emails, your device settings, or by contacting our support team.</p>
</li>
</ul>
<p><strong>f. Fraud Prevention and Abuse Detection</strong><br />To monitor and prevent:</p>
<ul>
<li>
<p>Fraudulent transactions</p>
</li>
<li>
<p>Misuse of our services or accounts</p>
</li>
</ul>
<p><strong>g. Enforcement of Terms and Protection of Rights</strong><br />To:</p>
<ul>
<li>
<p>Enforce our Terms of Use, policies, or other contractual obligations</p>
</li>
<li>
<p>Safeguard the rights, property, and safety of YOVHO, our customers, and third parties</p>
</li>
</ul>
<p><strong>h. Legal Defense</strong><br />To:</p>
<ul>
<li>
<p>Exercise our legal rights</p>
</li>
<li>
<p>Defend ourselves against legal claims or investigations</p>
</li>
</ul>
<p><strong>i. Business Transactions</strong><br />To facilitate or undergo:</p>
<p>&nbsp;</p>
</li>
<ul>
<li>
<p>Mergers, acquisitions, sales, or restructuring involving all or part of YOVHO&rsquo;s business or assets<br /><br /><br /><br /><br /><br /></p>
<h3><strong>Marketing and Preferences</strong></h3>
<p>YOVHO may use your personal information to provide you with marketing communications through a variety of channels, including:</p>
<ul>
<li>
<p>Email</p>
</li>
<li>
<p>SMS</p>
</li>
<li>
<p>Telephone</p>
</li>
<li>
<p>Postal mail</p>
</li>
<li>
<p>Application notifications (including silent notifications for tracking app installation status)</p>
</li>
<li>
<p>Social media platforms</p>
</li>
<li>
<p>Online advertising, including retargeting and personalized campaigns</p>
</li>
</ul>
<p>We may also use data analytics and technology to understand your preferences and interests in order to tailor our marketing content and recommendations, making them more relevant to you.</p>
<hr />
<h4><strong>Managing Your Marketing Preferences</strong></h4>
<p>You can manage your marketing preferences at any time. If you wish to opt out of receiving marketing emails, you can click the&nbsp;<strong>"unsubscribe"</strong>&nbsp;link included in every marketing email. Additionally, you may:</p>
<ul>
<li>
<p>Adjust your device settings to disable app notifications</p>
</li>
<li>
<p>Contact us to update or change your contact preferences</p>
</li>
<li>
<p>Object to direct marketing or related profiling by reaching out to us</p>
</li>
</ul>
<p>&nbsp;</p>
<p>For any of the above, please contact us at:<br /><img class="an1" draggable="false" src="https://fonts.gstatic.com/s/e/notoemoji/16.0/1f4e7/32.png" alt="📧" data-emoji="📧" />&nbsp;<strong><a rel="noopener">dataprotection@yovho.com, info@yovho.com<br /><br /><br /><br /></a></strong></p>
<h3><strong>Cookies and Other Tracking Technologies</strong></h3>
<p>YOVHO and its third-party service providers use cookies and similar tracking technologies to collect information about how you interact with our websites and mobile applications. These technologies help us to:</p>
<ul>
<li>
<p>Understand user behavior and preferences</p>
</li>
<li>
<p>Improve website functionality and performance</p>
</li>
<li>
<p>Deliver personalized content and advertisements</p>
</li>
<li>
<p>Measure the effectiveness of our marketing campaigns</p>
</li>
</ul>
<p>For detailed information about how we use cookies and how you can manage your cookie preferences, please refer to our&nbsp;<strong>[Cookie Statement]</strong>.</p>
<hr />
<h3><strong>Do-Not-Track Signals</strong></h3>
<p>At this time, our systems do not respond to browser&nbsp;<strong>Do-Not-Track (DNT)</strong>&nbsp;signals. If you wish to limit tracking, you may:</p>
<ul>
<li>
<p>Adjust your browser settings to disable or manage cookies</p>
</li>
<li>
<p>Follow the opt-out instructions provided in our&nbsp;<strong>Cookie Statement</strong></p>
</li>
<li>
<p>Use the opt-out mechanisms provided by third-party service providers directly</p>
</li>
</ul>
<p>&nbsp;</p>
<p>We continuously review and update our privacy and tracking practices in line with legal requirements and industry standards.<br /><br /><br /><br /><br /></p>
<h3><strong>Analytics and Advertising Services Provided by Third Parties</strong></h3>
<p>YOVHO engages trusted third-party service providers to deliver audience measurement, analytics, and advertising services. These providers help us better understand how users interact with our websites and mobile applications, enable personalized marketing experiences, and assess the effectiveness of our advertising campaigns across various digital platforms.</p>
<p>To enhance user experience and relevance, we also utilize the&nbsp;<strong>Google Places API</strong>, which offers location-based suggestions based on user input or device location.</p>
<p>We may permit selected third parties to:</p>
<ul>
<li>
<p>Perform web and app analytics on our behalf</p>
</li>
<li>
<p>Deliver interest-based advertisements across websites, apps, and social platforms</p>
</li>
<li>
<p>Monitor and report on the performance of our advertisements</p>
</li>
</ul>
<p>These third-party providers may use cookies, web beacons, pixels, SDKs, and other similar tracking technologies to recognize your device and collect data when you access YOVHO services or interact with other digital platforms.</p>
<p>For a comprehensive overview of these technologies and how to manage or disable them, please refer to our&nbsp;<strong>[Cookie Statement]</strong>.</p>
<hr />
<h3><strong>Google Services</strong></h3>
<p>YOVHO integrates the&nbsp;<strong>Google Places API</strong>&nbsp;to provide predictive place suggestions and enhanced search functionality. By using this feature, you are also subject to:</p>
<ul>
<li>Google Maps Term Of Service&nbsp;</li>
<li>
<p>Google Privacy Policy</p>
</li>
</ul>
<p>&nbsp;</p>
<p>To prevent your data from being used by&nbsp;<strong>Google Analytics</strong>, you may install the official Google Analytics Opt-out Browser Add-on.&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<br /><br /></p>
<h3><strong>Sharing Your Information</strong></h3>
<p>We share your personal information within the&nbsp;<strong>YOVHO Group</strong>&nbsp;and with carefully selected third parties who support the delivery of our services. We also disclose information where required by applicable law or in accordance with regulatory obligations. Below is a detailed overview of the types of entities your information may be shared with:</p>
<h4>We may share your personal information with:</h4>
<p><strong>a. Other entities within the YOVHO Group:</strong><br />To support internal operations and provide you with a seamless experience across our global services.</p>
<p><strong>b. Accommodation providers and managers:</strong><br />To fulfill your booking and accommodation preferences. For example, we share your name, check-in details, and special requests directly with the accommodation provider.</p>
<p><strong>c. Authorized service providers and business partners:</strong><br />These include entities who assist us in delivering our services, technology infrastructure, customer support, payment processing, marketing, or promotional campaigns. This also includes third-party platforms that integrate with our services or that we integrate with.</p>
<p><strong>d. Referral contacts:</strong><br />If you use features that allow you to refer friends, contacts, or colleagues, we may share your name with those individuals.</p>
<p><strong>e. Public forums and social features:</strong><br />If you submit content (such as reviews or comments) on public platforms associated with YOVHO or engage with features that allow you to share content via social media or other networks, that content may become visible to the general public based on your privacy settings. Please review the privacy policies of any third-party platforms you engage with.</p>
<p><strong>f. Legal and regulatory authorities:</strong><br />Where required, we may disclose your information to law enforcement, governmental agencies, regulatory bodies, or other authorities in accordance with legal obligations or lawful requests.</p>
<p><strong>g. Judicial or police authorities:</strong><br />We may disclose data if required to comply with a court order, enforce our rights, or cooperate in a lawful investigation.</p>
<p><strong>h. Parties to a business transaction:</strong><br />In the event of a potential or actual sale, merger, acquisition, financing, restructuring, or transfer of all or part of the YOVHO business or its assets, your data may be shared with relevant third parties involved in the transaction.</p>
<p>&nbsp;</p>
<p><strong>i. Aggregated or anonymised data recipients:</strong><br />We may share data that has been aggregated, pseudonymised, or anonymised in such a way that it cannot reasonably be used to identify any individual. This data may be used for analytics, research, or reporting purposes.<br /><br /><br /><br /></p>
<h3><strong>Questions and Contact Information</strong></h3>
<p>If you have any questions, comments, concerns, or complaints regarding this Privacy Notice or our handling of your personal information, please feel free to contact our Privacy Team.</p>
<p><strong>Email:</strong>&nbsp;[<a rel="noopener">privacy@yovho.com</a>]<br />We are committed to addressing your concerns promptly and transparently.</p>
<hr />
<h3><strong>Changes to This Privacy Notice</strong></h3>
<p>This Privacy Notice is effective as of the "Last Updated" date indicated above. YOVHO may revise or update this Privacy Notice from time to time to reflect changes in our practices, legal or regulatory requirements, or improvements to our services.</p>
<p>We encourage you to review this notice periodically. Updates will be posted on our website and mobile application. If the changes are material, we will provide a more prominent notice or seek your consent where required by applicable law.</p>
<hr />
<h3><strong>Additional Information for Individuals in the European Union (EU) and European Economic Area (EEA)</strong></h3>
<p>If you are located in the EU or EEA, the following additional information applies to you under the&nbsp;<strong>General Data Protection Regulation (GDPR):</strong></p>
<ul>
<li>
<p><strong>Data Controller:</strong><br />The entity responsible for the processing of your personal data is YOVHO.</p>
</li>
<li>
<p><strong>Your Rights:</strong><br />Subject to applicable law, you have the following rights:</p>
<ul>
<li>
<p>The right to access your personal data</p>
</li>
<li>
<p>The right to rectify inaccurate or incomplete data</p>
</li>
<li>
<p>The right to request erasure (&lsquo;right to be forgotten&rsquo;)</p>
</li>
<li>
<p>The right to restrict or object to processing</p>
</li>
<li>
<p>The right to data portability</p>
</li>
<li>
<p>The right to withdraw consent (where processing is based on consent)</p>
</li>
<li>
<p>The right to lodge a complaint with a supervisory authority</p>
</li>
</ul>
</li>
<li>
<p><strong>Legal Basis for Processing:</strong><br />We process your personal data only where we have a valid legal basis, including performance of a contract, compliance with legal obligations, your consent, and legitimate interests as outlined earlier in this notice.</p>
</li>
<li>
<p><strong>International Transfers:</strong><br />If your personal data is transferred outside the EU/EEA, we ensure adequate safeguards are in place, such as Standard Contractual Clauses approved by the European Commission, to protect your information.</p>
</li>
</ul>
<p>&nbsp;</p>
<p>If you wish to exercise any of your data protection rights or need further details on how your information is processed, please contact us at:&nbsp;<strong><a rel="noopener">privacy@yovho.com<br /><br /><br /><br /></a></strong></p>
<h3>International Data Transfers</h3>
<p>YOVHO operates global information systems and infrastructure, which means your personal data may be transferred to and processed in countries outside your country of residence. This includes transfers to countries outside the European Economic Area (EEA), such as Pakistan and the United Arab Emirates (UAE), for the purposes described in this Privacy Notice.</p>
<p>Some of these countries may not offer the same level of data protection as those within the EEA and may not be recognized by the European Commission as providing adequate safeguards for personal data.</p>
<p>However, YOVHO is committed to ensuring your personal information is protected regardless of where it is processed. Where international data transfers occur, we implement appropriate legal safeguards in accordance with applicable data protection laws. These safeguards may include:</p>
<ul>
<li>
<p>Standard Contractual Clauses (SCCs) approved by the European Commission;</p>
</li>
<li>
<p>Binding Corporate Rules (BCRs), where applicable;</p>
</li>
<li>
<p>Other lawful transfer mechanisms or contractual protections that ensure your information is subject to a level of protection essentially equivalent to that under EEA standards.</p>
</li>
</ul>
<p>If you would like more information about these safeguards, including access to relevant documentation, please contact us at:<br /><img class="an1" draggable="false" src="https://fonts.gstatic.com/s/e/notoemoji/16.0/1f4e7/32.png" alt="📧" data-emoji="📧" />&nbsp;<a rel="noopener">privacy@yovho.com</a></p>
<h3><br /><br /><br /></h3>
<h3><strong>Data Retention</strong></h3>
<p>We retain your personal information in accordance with&nbsp;<strong>YOVHO&rsquo;s data retention policies</strong>&nbsp;and applicable legal and regulatory obligations. The retention period may vary depending on the nature of your interaction with us and the purposes for which your data was collected.</p>
<p>In certain circumstances, we may need to retain your information for longer periods&mdash;for example, where required to comply with legal obligations, resolve disputes, enforce our agreements, or manage claims related to your booking or experience.</p>
<p>To determine the appropriate retention period, we consider several factors, including:</p>
<p>a. The duration of your relationship with YOVHO and the services or bookings you have used;</p>
<p>b. The need to maintain accurate records to demonstrate that we have met our legal, contractual, and regulatory obligations;</p>
<p>c. Applicable statutory limitation periods under which legal claims may be filed;</p>
<p>d. Retention requirements set out in relevant laws, regulations, industry standards, or issued by regulatory authorities; and</p>
<p>e. The existence of any actual or potential disputes, complaints, audits, or investigations.</p>
<p>&nbsp;</p>
<p>Once your personal data is no longer required for the purposes set out in this Privacy Notice, and we are not legally obligated to retain it, we will securely delete or anonymize it.<br /><br /><br />&nbsp;<strong>Your legal rights :</strong></p>
<p>Data protection laws in the European Economic Area (EEA) and certain other countries provide individuals with specific rights regarding the personal information that Yovho holds about them, whether stored electronically or on paper. These rights may include the ability to access, correct, delete, restrict, object to processing, transfer, or withdraw consent to the processing of your personal information. Some exceptions may apply.</p>
<p>Specifically, you may have the following rights:</p>
<p><strong>a. Right of Access</strong>&nbsp;&ndash; You have the right to request details of the personal information we hold about you and to obtain a copy of that data.</p>
<p><strong>b. Right to Rectification</strong>&nbsp;&ndash; You can request that we correct any inaccurate or incomplete personal information we hold about you.</p>
<p><strong>c. Right to Erasure ("Right to be Forgotten")</strong>&nbsp;&ndash; You can request the deletion of certain personal information held about you.</p>
<p><strong>d. Right to Restriction of Processing</strong>&nbsp;&ndash; You may request that we only use your personal information for limited purposes.</p>
<p><strong>e. Right to Object</strong>&nbsp;&ndash; You may object to the processing of your personal information, including for direct marketing purposes.</p>
<p><strong>f. Right to Data Portability</strong>&nbsp;&ndash; You have the right to request that personal information you have provided to us be transferred to you or another service provider in a structured, commonly used, and machine-readable format.</p>
<p><strong>g. Right to Withdraw Consent</strong>&nbsp;&ndash; Where we rely on your consent to process personal information, you may withdraw that consent at any time. This withdrawal does not affect the lawfulness of any processing based on your consent before its withdrawal.</p>
<p>Please note that these rights may not apply in all circumstances. If we are unable to comply with your request, we will provide a clear explanation. To help us process your request, we may ask you to verify your identity and provide additional information.</p>
<p>&nbsp;</p>
<p>For more information or to exercise your rights, please contact our Privacy Team at:&nbsp;<strong>[<a rel="noopener">dataprotection@yovho.com</a>]</strong>&nbsp; &nbsp;<br /><br /></p>
</li>
</ul>
</ul>
<div>&nbsp;</div>
</div>
<div>
<h3><strong>Data Protection Contacts</strong></h3>
<p>If you have any questions, comments, complaints, or suggestions regarding this Privacy Notice, or any concerns about how your personal information is processed, please contact Yovho&rsquo;s Data Protection Officer and Privacy Team at:</p>
<p><img class="an1" draggable="false" src="https://fonts.gstatic.com/s/e/notoemoji/16.0/1f4e7/32.png" alt="📧" data-emoji="📧" />&nbsp;<strong><a rel="noopener">dataprotection@yovho.com</a></strong></p>
<p>You also have the right to lodge a complaint with your local data protection authority. If you are located in the European Union (EU), you may submit a complaint to a supervisory authority in the country or territory where:</p>
<ol>
<li>
<p>You reside,</p>
</li>
<li>
<p>You work, or</p>
</li>
<li>
<p>The alleged data protection breach occurred.</p>
</li>
</ol>
</div>












        </div>
    </div>
</div>

















        
          </div>
        )
    }
}

export default Home;